import { render, staticRenderFns } from "./PageAssets.vue?vue&type=template&id=018b15aa&"
import script from "./PageAssets.vue?vue&type=script&lang=js&"
export * from "./PageAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports